import { render, staticRenderFns } from "./detail-list.vue?vue&type=template&id=8748af70&scoped=true&"
import script from "./detail-list.vue?vue&type=script&lang=js&"
export * from "./detail-list.vue?vue&type=script&lang=js&"
import style0 from "./detail-list.vue?vue&type=style&index=0&id=8748af70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8748af70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8748af70')) {
      api.createRecord('8748af70', component.options)
    } else {
      api.reload('8748af70', component.options)
    }
    module.hot.accept("./detail-list.vue?vue&type=template&id=8748af70&scoped=true&", function () {
      api.rerender('8748af70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/detail-list.vue"
export default component.exports